import { Box, Heading, Notification, Switch } from '@veracity/vui'
import { useState } from 'react'

import { PageLoader } from '@/components'
import { IsoBa, SystemConfigurations } from '@/interfaces'

import { useAggregatedSummary } from '../../hooks'
import { ScenarioResultsAggregatesTabPreview } from './ScenarioResultsAggregatesTabPreview'

interface Props {
  scenarioId: number
  scenarioConfiguration: SystemConfigurations
  projectIsoBa?: IsoBa
}

export const ScenarioResultsAggregatesTab = ({
  scenarioId,
  scenarioConfiguration,
  projectIsoBa
}: Props) => {
  const [isAnnuallySelected, setIsAnnuallySelected] = useState(true)

  const { sections, dateSection, isFetching, areResultsEmpty } =
    useAggregatedSummary(scenarioId, scenarioConfiguration, isAnnuallySelected, projectIsoBa)

  if (areResultsEmpty)
    return (
      <Notification
        status="warning"
        title="Data Unavailable"
        text="Apologies, results are unavailable due to backward incompatibility."
        w="100%"
      />
    )

  return (
    <Box column p={2} gap={3} bg="white">
      <Box w="100%" justify="center">
        <Switch
          labelLeft="Monthly"
          labelRight="Annually"
          checked={isAnnuallySelected}
          onChange={ev => setIsAnnuallySelected(ev.target.checked)}
        />
      </Box>

      {isFetching ? (
        <PageLoader />
      ) : (
        <>
          <Heading size="h5">
            Dispatch results summary (
            {isAnnuallySelected ? 'Annually' : 'Monthly'})
          </Heading>

          <ScenarioResultsAggregatesTabPreview
            sections={sections}
            dateSection={dateSection}
          />
        </>
      )}
    </Box>
  )
}
